<template>
  <div class="pageStyle">
    <div v-show="!emptryShow" class="pageStyleBox">
      <div class="header">
        <div class="describe">
          <div class="describe-title">
            <span><van-icon name="good-job" />推广说明</span>
          </div>
          <div class="tips">
            <div>推广收益=客户查询价-推广人成本价</div>
            <div>
              在下方“自定义价格”处选择报告类型，设置客户查询价（元）即可了解推广收益。
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="form">
          <div class="form-title">
            <div>
              <span>{{ isAddFlag ? "自定义价格码" : "编辑价格码" }}</span>
              <span v-show="isAddFlag" @click="toPage('companyRepCode')"
                >查看历史码<van-icon name="arrow" size="3vw"
              /></span>
            </div>
            <div>
              <span>填写报告价格 </span><van-icon name="arrow" /> 生成推广海报
              <van-icon name="arrow" /><span>扫码获取企业报告</span>
            </div>
          </div>
          <van-form
            @submit="onSubmit"
            label-width="42vw"
            input-align="right"
            error-message-align="right"
          >
            <div v-for="(item, index) in reportList" :key="index">
              <!-- 报告名称 -->
              <div class="title">
                <img :src="formTitleIcon[index]" alt="" /><span>{{
                  item.name
                }}</span>
              </div>
              <div class="form-box">
                <van-field
                  clearable
                  :id="item.priceKey"
                  v-model="form[item.priceKey]"
                  :placeholder="item.range"
                  @input="calculateIncome($event, index, item.range)"
                  type="digit"
                  :rules="[
                    { required: true, message: '请填写报告价格' },
                    {
                      validator: checkValueRange,
                      message: '价格必须在' + item.range + '之间',
                    },
                  ]"
                >
                  <template #label>
                    <span>报告价格（元）</span>
                    <van-icon name="question-o" @click="toTips('price')" />
                  </template>
                </van-field>
                <van-field name="radio">
                  <template #input>
                    <van-radio-group
                      v-model="form[item.flagKey]"
                      direction="horizontal"
                    >
                      <van-radio
                        checked-color="#255bc8"
                        shape="square"
                        :name="true"
                        >是</van-radio
                      >
                      <van-radio
                        checked-color="#255bc8"
                        shape="square"
                        :name="false"
                        >否</van-radio
                      >
                    </van-radio-group>
                  </template>
                  <template #label>
                    <span>是否上架</span>
                    <van-icon name="question-o" @click="toTips('flag')" />
                  </template>
                </van-field>
                <van-field
                  class="income"
                  v-show="item.income"
                  v-model="item.income"
                  label="推广收益（元）"
                  readonly
                  ><template #label>
                    <span>推广收益（仅供参考）</span
                    ><van-icon name="question-o" @click="toTips('income')" />
                  </template>
                </van-field>
              </div>
            </div>
            <div class="btn" v-if="isAddFlag">
              <van-button round block type="info" native-type="submit"
                >生成推广海报</van-button
              >
            </div>
            <div class="btn" v-else>
              <van-button round block type="info" native-type="submit"
                >保存修改</van-button
              >
            </div>
          </van-form>
        </div>
      </div>
    </div>
    <van-empty v-show="emptryShow" description="价格码不存在" />
    <!-- 问号提示弹窗 -->
    <tipsDialog ref="tipsDialog"></tipsDialog>
    <!-- 价格码海报弹窗 -->
    <van-dialog
      class="reportPosterShow"
      v-model="reportPosterShow"
      close-on-click-overlay
      :showConfirmButton="false"
    >
      <img :src="reportPosterImg" />
    </van-dialog>
  </div>
</template>

<script>
import {
  xcCompanyRepoCode,
  genPricePost,
  getRepoCodeConfig,
  putRepoCodeConfig,
} from "@/api/companyRep.js";
import { getCurrentChannelInfo } from "@/api/login.js";
import { simpleUuid } from "@/utils/index";
import Vue from "vue";
import { Form, Toast, Field, Dialog, Empty, Notify } from "vant";
import tipsDialog from "./module/tipsDialog.vue";
Vue.use(Form);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Empty);
Vue.use(Notify);
export default {
  components: { tipsDialog },
  mounted() {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "加载中",
    });
    // 获取渠道用户信息
    getCurrentChannelInfo()
      .then((res) => {
        this.channelInfo = res;
        Toast.clear();
      })
      .catch((err) => {
        console.log("err", err);
        Toast.clear();
      });
    // 判断是否为新增
    this.isAdd();
  },
  data() {
    return {
      emptryShow: false,
      channelInfo: {},
      reportPosterShow: false,
      reportPosterImg: "",
      form: {
        besoBasePrice: null,
        besoBaseFlag: true,
        besoProPrice: null,
        besoProFlag: true,
        besoPersonPrice: null,
        besoPersonFlag: true,
      },
      repId: "",
      isAddFlag: true,
      submitTxt: "生成推广海报",
      reportList: [
        {
          name: "企业经营基础报告",
          range: "30-2000",
          priceKey: "besoBasePrice",
          flagKey: "besoBaseFlag",
          income: "",
        },
        {
          name: "企业涉税风险报告",
          range: "50-3000",
          priceKey: "besoProPrice",
          flagKey: "besoProFlag",
          income: "",
        },
        {
          name: "个人信息报告",
          range: "28-599",
          priceKey: "besoPersonPrice",
          flagKey: "besoPersonFlag",
          income: "",
        },
      ],
      formTitleIcon: [
        "https://static.xchengtech.cn/9d3b6cdb0af94ba882728ada8e144bfb.png",
        "https://static.xchengtech.cn/7900fb1e419c453e84296ef8a849076f.png",
        "https://static.xchengtech.cn/6be689d4503e4236bad02420c27beb12.png",
      ],
    };
  },
  methods: {
    isAdd() {
      // 如果有id 则为修改操作
      let id = this.$route.query.id;
      if (id) {
        this.isAddFlag = false;
        this.repId = id;
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
        });
        // 根据id获取价格码配置
        getRepoCodeConfig(id)
          .then((res) => {
            Toast.clear();
            // 价格码不存在
            if (!res.id) {
              this.emptryShow = true;
              return false;
            }
            // 注意价格是分
            this.form = res;
            this.form.besoBasePrice = res.besoBasePrice / 100;
            this.form.besoProPrice = res.besoProPrice / 100;
            this.form.besoPersonPrice = res.besoPersonPrice / 100;
          })
          .catch((err) => {
            Toast.clear();
            console.log("err", err);
          });
      }
      console.log("id", id);
    },
    toPage(name) {
      // 如果是新增
      if (this.isAddFlag == true) {
        this.$router.push({ path: "/" + name });
      } else {
        this.$router.replace({ path: "/" + name });
      }
    },
    // 计算收益
    calculateIncome(e, index, range) {
      if (e) {
        // 解析规则获取价格范围
        let s = range.split("-");
        let min = s[0];
        let max = s[1];

        // 判断范围是否正确
        const number = Number(e);
        if (number >= min && number <= max) {
          // 判断报告类型
          // 1. 企业经营基础报告
          if (index === 0) {
            // 订单⾦额<=500 按成本30 进⾏结算;
            if (e <= 500) {
              this.reportList[index].income = e - 30;
            }
            // 订单⾦额>500 渠道拿70%公司留30%
            else {
              let s = e * 0.7;
              this.reportList[index].income = s.toFixed(2);
            }
          }
          // 企业涉税风险报告
          if (index === 1) {
            // 订单⾦额<=500 按成本68 进⾏结算;
            if (e <= 500) {
              this.reportList[index].income = e - 68;
            }
            // 订单⾦额>500 渠道拿70%公司留30%
            else {
              let s = e * 0.7;
              this.reportList[index].income = s.toFixed(2);
            }
          }
          // 2. 个人信息报告
          if (index === 2) {
            // 订单⾦额<=199 按成本28 进⾏结算;
            if (e <= 199) {
              this.reportList[index].income = e - 28;
            }
            // 订单⾦额>199 渠道拿70%公司留30%
            else {
              let s = e * 0.7;
              this.reportList[index].income = s.toFixed(2);
            }
          }
        } else {
          this.reportList[index].income = "";
          console.log("价格不正确");
        }
      }
    },
    onSubmit() {
      // 判断是新增还是修改
      if (this.isAddFlag) {
        // 新增
        let body = {
          channelId: this.channelInfo.id,
          channelName: this.channelInfo.name,
          code: simpleUuid(),
          // 注意用户填写的是元 传值时要转为分
          besoBasePrice: this.form.besoBasePrice * 100,
          besoBaseFlag: this.form.besoBaseFlag,
          besoProPrice: this.form.besoProPrice * 100,
          besoProFlag: this.form.besoProFlag,
          besoPersonPrice: this.form.besoPersonPrice * 100,
          besoPersonFlag: this.form.besoPersonFlag,
        };
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
        });
        // 新增价格码
        xcCompanyRepoCode(body)
          .then((res) => {
            // 获取海报
            genPricePost(res.code)
              .then((ress) => {
                Toast.clear();
                this.reportPosterImg = ress;
                this.reportPosterShow = true;
                this.toReset();
              })
              .catch((errr) => {
                console.log("errr", errr);
                Toast.clear();
              });
          })
          .catch((err) => {
            console.log("err", err);
            Toast.clear();
          });
      } else {
        // 修改
        let body = {
          ...this.form,
        };
        // 注意用户填写的是元 传值时要转为分
        body.besoBasePrice = body.besoBasePrice * 100;
        body.besoProPrice = body.besoProPrice * 100;
        body.besoPersonPrice = body.besoPersonPrice * 100;
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
        });
        putRepoCodeConfig(body)
          .then((res) => {
            Toast.clear();
            Notify({ type: "success", message: "修改成功" });
            this.toPage("companyRepCode");
            // 获取海报
            // genPricePost(this.repId)
            //   .then((ress) => {
            //     Toast.clear();
            //     this.reportPosterImg = ress;
            //     this.reportPosterShow = true;
            //   })
            //   .catch((errr) => {
            //     console.log("errr", errr);
            //     Toast.clear();
            //   });
          })
          .catch((err) => {
            console.log("err", err);
            Toast.clear();
          });
      }
    },
    // 重置填写内容
    toReset() {
      this.form = {
        besoBasePrice: null,
        besoBaseFlag: true,
        besoProPrice: null,
        besoProFlag: true,
        besoPersonPrice: null,
        besoPersonFlag: true,
      };
      this.reportList = [
        {
          name: "企业经营基础报告",
          range: "30-2000",
          priceKey: "besoBasePrice",
          flagKey: "besoBaseFlag",
          income: "",
        },
        {
          name: "企业涉税风险报告",
          range: "99-3000",
          priceKey: "besoProPrice",
          flagKey: "besoProFlag",
          income: "",
        },
        {
          name: "个人信息报告",
          range: "28-599",
          priceKey: "besoPersonPrice",
          flagKey: "besoPersonFlag",
          income: "",
        },
      ];
    },
    toTips(name) {
      this.$refs.tipsDialog[name + "Show"] = true;
    },
    scrollToDiv(divId) {
      var div = document.getElementById(divId);
      div.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    checkValueRange(val, rule) {
      // 解析规则获取价格范围
      let s = rule.message.split("-");
      let min = s[0].split("在")[1];
      let max = s[1].split("之")[0];
      // 判断范围是否正确
      const number = Number(val);
      return number >= min && number <= max;
    },
  },
};
</script>

<style scoped>
.pageStyle {
}
.pageStyleBox {
  min-height: 100vh;
  background: url("https://static.xchengtech.cn/6254f77a4d4746b79e47d13ec8afcff6.jpg");
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding: 4vw;
  font-size: 3.6vw;
  background-color: #daf8f8;
}
.header {
  padding-top: 42vw;
}
.header .title {
  font-weight: 600;
  padding-bottom: 4vw;
  padding-left: 4vw;
  color: white;
  font-size: 7vw;
  display: grid;
  gap: 2vw;
}
.header .title span {
  display: block;
}
.header .describe {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: white;
  border-radius: 14px;
  padding: 4vw;
  box-shadow: 0 4px 12px #a5d2f6;
}
.header .describe-title {
  padding-bottom: 3vw;
}
.header .describe-title span {
  color: white;
  background-color: #255bc8;
  font-weight: 600;
  font-size: 4vw;
  padding: 1vw 2vw;
  border-radius: 4px;
}
.header .describe-title .van-icon {
  padding-right: 1vw;
}
.header .describe .tips {
  /* padding: 2vw 4vw; */
  /* border: 1px solid #396efe; */
  line-height: 7vw;
  border-radius: 14px;
}
.content {
  margin: 4vw 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: white;
  border-radius: 14px;
  padding: 4vw;
  box-shadow: 0 4px 12px #a5d2f6;
}
.content .title {
  display: flex;
  align-items: center;
  gap: 1vw;
  padding-top: 4vw;
}
.content .title img {
  display: block;
  height: 4vw;
}
.content .title span {
  color: #255bc8;
  font-size: 4vw;
  font-weight: 600;
}
.content .form {
}
.content .form .form-title {
  padding-bottom: 2vw;
}
.content .form .form-title div:nth-of-type(1) {
  padding-top: 2vw;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  text-align: center;

  gap: 2vw;

  padding-bottom: 3vw;
}
.content .form .form-title div:nth-of-type(1) span:nth-of-type(1) {
  font-size: 6vw;
  font-weight: 600;
  color: #255bc8;
}
.content .form .form-title div:nth-of-type(1) span:nth-of-type(2) {
  color: #255bc8;
}
.content .form .form-title div:nth-of-type(2) {
  display: flex;
  align-items: center;
  justify-content: left;
  text-align: center;
  color: #797a83;
}
.content .form .form-title div:nth-of-type(2) .van-icon {
  font-size: 3vw;
}
.content .form .form-title img {
  display: block;
  height: 4vw;
}
.content .form .form-box {
  padding: 0 5vw;
}
.content .form .form-box .van-cell:nth-of-type(3) {
  border-bottom: 1px solid #f5f6f7;
}
.content .form .van-cell {
  padding: 4vw 0;
  align-items: center;
}
.content .form .van-radio-group .van-radio:nth-of-type(2) {
  margin-right: 0;
}
.content .form .van-cell /deep/ .van-radio__icon {
  font-size: 4vw;
}
.content .form .van-cell /deep/ .van-cell__title {
  /* font-weight: 600; */
  color: #0d1323;
}
.content .form .van-switch {
  font-size: 4vw;
}
.content .form .van-cell::after {
  left: 0;
  right: 0;
}
.content .btn {
  padding-top: 4vw;
  border-radius: 4px;
}
.content .btn .van-button {
  letter-spacing: 4px;
  /* padding: 3vw 0; */
  height: 13vw;
  background-image: linear-gradient(90deg, #3796ff, #1b5dd9);
  color: #fff;
  border-radius: 8px;

  font-weight: 600;

  font-size: 4vw;
}
.content .income /deep/ .van-field__control {
  color: #fc871d;
  font-weight: 600;
}
.reportPosterShow {
  border-radius: 0;
}
.reportPosterShow img {
  display: block;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/view/companyRepCodeInfo/index.vue